import { useSelector } from "react-redux";
import { formatDate } from "../../helpers/date";
import {
  getChatByUserIdApi,
  selectUserToChat,
  updateMeta,
} from "../../redux-toolkit/slices/chatSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";

const ChatSidebar = () => {
  const { meta } = useSelector((state: RootState) => state.chat);
  const dispatch = useAppDispatch();

  const handleUserSwitch = (chat: IChatMeta) => {
    dispatch(selectUserToChat(chat));
    dispatch(getChatByUserIdApi({ userId: chat.userId._id, page: 1 }));
    const _updatedMeta = meta.map((item) => {
      if (item.userId._id === chat.userId._id) {
        return {
          ...item,
          unreadCountForAdmin: 0,
        };
      }
      return item;
    });
    dispatch(updateMeta(_updatedMeta));
  };
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3 className="sidebar-header-text"></h3>
        <button className="add-chat">+</button>
      </div>
      <ul className="chat-list">
        {meta.map((chat, index) => (
          <li
            onClick={(e) => {
              handleUserSwitch(chat);
            }}
            key={index}
            className="chat-item"
          >
            <div className="chat-info">
              <h4>
                {chat.userId.firstName} {chat.userId.lastName}
              </h4>
              <p className="user-last-message">{chat.lastMessage.content}</p>
            </div>
            <div>
              <span className="chat-time">
                {formatDate(chat.lastMessage.createdAt)}
              </span>
              {chat.unreadCountForAdmin > 0 && (
                <p style={{ textAlign: "right", marginTop: "2px" }}>
                  <span className="unread-count">
                    {chat.unreadCountForAdmin}
                  </span>
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChatSidebar;
